import { useEffect, useState } from 'react';
export const usePersistedState = (key, initialValue, storageType = 'localStorage') => {
    const [state, setState] = useState(() => {
        try {
            const storage = storageType === 'localStorage'
                ? localStorage
                : sessionStorage;
            const item = storage.getItem(key);
            if (item) {
                return JSON.parse(item);
            }
        }
        catch (error) {
            console.error(`Error loading ${key} from ${storageType}:`, error);
        }
        return initialValue;
    });
    useEffect(() => {
        try {
            const storage = storageType === 'localStorage'
                ? localStorage
                : sessionStorage;
            storage.setItem(key, JSON.stringify(state));
        }
        catch (error) {
            console.error(`Error saving ${key} to ${storageType}:`, error);
        }
    }, [key, state, storageType]);
    return [state, setState];
};
